import { Stack, Paper, Group } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ResultMaps } from '../../components/result-maps/result-maps';
import { intercultureQueries } from '../../data-access/queries/interculture';

import classes from './page.module.css';

import { useAuth } from '@auth/data-access';
import { FORM_STATUS, hasDistriAccess, ROLES, useQueriesWithGlobal } from '@data-access';
import { ActionsMenuItem, TsrButtonLink, ActionsMenu } from '@ui';

export function IntercultureResultMapsPage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { formId, crop } = useParams({
    from: '/_app/interculture_/$crop/$formId/result/maps',
  });

  const queries = useQueriesWithGlobal(intercultureQueries);
  const { data } = useSuspenseQuery(
    queries.result({
      id: Number(formId),
      crop,
    }),
  );

  const menuActions: ActionsMenuItem[] = [
    {
      type: 'action',
      label: 'Supprimer',
      color: 'red',
      icon: IconTrash,
      props: {
        disabled: true,
      },
      onClick: () => null,
    },
  ];

  return (
    <Stack className={classes.navCol}>
      <Paper>
        <Group justify="space-between">
          <div />
          <Group>
            {hasDistriAccess(user?.user_access) ? (
              <TsrButtonLink
                params={{
                  crop,
                  formId,
                }}
                to="/interculture/$crop/$formId/result/sat-images"
              >
                {t('common.satellite_images')}
              </TsrButtonLink>
            ) : null}
            <ActionsMenu items={menuActions}>
              <ActionsMenu.Button disabled />
            </ActionsMenu>
          </Group>
        </Group>
      </Paper>
      <Paper h="100%" p={0}>
        <ResultMaps
          estimatedYieldLegend={data.maps?.estimated_yieldlegend ?? null}
          estimatedYieldMap={data.maps?.estimated_yieldmap ?? null}
          realYieldLegend={data.maps?.real_yieldlegend ?? null}
          realYieldMap={data.maps?.real_yieldmap ?? null}
          status={data.maps?.status ?? FORM_STATUS.PENDING}
        />
      </Paper>
    </Stack>
  );
}

export default IntercultureResultMapsPage;
